<template>
  <div class="deals-page">
    <app-header :loggedIn="true" />
    <deals-list v-if="isAccess" :extended="true" />
    <login-required v-if="!isAccess" />
  </div>
</template>

<script>
import DealsList from '@/components/deals/list'
import AppHeader from '@/components/common/app-header'
import LoginRequired from '@/components/common/login-required'

export default {
  name: 'deals',
  components: {
    AppHeader,
    LoginRequired,
    DealsList
  },
  computed: {
    isAccess () {
      return this.$store.getters['tokens/isAccessToken']
    }
  }
}
</script>
